import React, { useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { Link, useParams } from "react-router-dom";
import { useAssetsApi } from "../../../store/api/hooks/assetsApiHook";
import { useAppLoader } from "../../../_common/pageLoader/appLoaderHook";
import Icon from "../../../components/icons";
import { Controller, useForm } from "react-hook-form";
import FileUpload from "../../../components/elements/form/fileUplaod";
import toast from "react-hot-toast";
import moment from "moment";
import { DATE_FORMAT } from "../../../_common/constant";
import { useDialog } from "../../../store/api/hooks/dialogHook";
import { useWorkRequestApi } from "../../../store/api/hooks/workRequestApiHook";
interface Props {
    _ref: any
}


const WorkFiles: React.FC<Props> = ({ _ref }) => {
    const params: any = useParams();
    const assetsAPI = useAssetsApi();
    const workRequestAPI: any = useWorkRequestApi();
    const [columnDefs, setColumnDefs] = useState<any[] | null>(null);
    const [gridApi, setGridApi] = useState<any>(null);
    const [attachmentList, setAttachmentList] = React.useState<any[]>([]);
    const { confirm } = useDialog();
    const [gridColumnApi, setGridColumnApi] = useState<any>(null);
    const [attachments, setAttachment] = useState<[]>([]);
    const { showLoader, hideLoader } = useAppLoader();
    let imgExt = ['.png', '.jpg', '.jpeg', '.webp'];
    const { control, reset, handleSubmit, formState: { errors }, } = useForm<any>();

    const getAttachmentList = (assetID: any = params.id) => {
        const payload = {
            workRequestID: assetID,
        };
        showLoader();


        workRequestAPI.GetWorkRequestImages(payload, (resp: any) => {
            hideLoader();
            console.log("resp===========?", resp)
            const attachmentList = resp?.files ? resp?.files : [];
            setAttachmentList(attachmentList);


        }, (error: any) => {
            hideLoader();

        })
    };

    useEffect(() => {
        if (params.id) {
            getAttachmentList(params.id);
        }
    }, [params]);

    useEffect(() => {
        if (_ref?.current) {
            _ref.current.reload = getAttachmentList
        }

    }, [_ref]);

    return (
        <div className={ `mt-3` } ref={_ref}>
            <div className='flex justify-between items-center py-2 mb-0'>
                <h4 className={ `py-2 pl-1` } style={{ color: `#000`, fontWeight: `bold`, fontSize: 15 }}>Images</h4>
            </div>
            { attachmentList && attachmentList.length > 0 && <div>
                    <div className={ `flex items-center gap-2` }>
                        { attachmentList.map((item: any, index: number) => {
                                const found = imgExt.some((word) => item.originalFileName.includes(word));
                                //const found = true;
                                return (
                                    <div key={`attachmentList${index}`} className={ `border flex text-[0.813rem] justify-center items-center relative overflow-hidden` } style={{ width: 130, height: 92, borderRadius: 8, borderColor: `#ccc` }}>
                                        <Link to={item.fullFilePath} target='_blank' title={item.originalFileName}>
                                            {found ? <img src={item.fullFilePath} alt={item.originalFileName} className="max-w-full" style={{ objectFit: `cover`, objectPosition: `center`}} /> : <Icon name={ `noimage` } className="text-gray-500" size={2} />}                                            
                                        </Link>
                                        {/* <span className='text-sm text-gray-400 inline-block ms-1'>({item.fileSize})</span> */}
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            }
        </div>
    );
};

export default WorkFiles;
